@if (tableType === 'table-default' && table.body.length > 0) {
	<lbca-table class="table-list-default"
		[table]="table"
		[dataAttr]="dataAttr"
		[field]="fieldValues"
		[disabled]="isDisabled"
		[lineCickable]="lineCickable"
		(changeValue)="changeVal($event)"
		(clickLine)="clickEvent($event)"
		(order)="orderTable($event)"
		(selectedPage)="onPageChange($event)"
		[cardData]="cardInfo"
		[editParallel]="editParallel"
		[loading]="table.config?.pagination ? !isLoaded : false"
	 />
}

@if (tableType === 'table-condensed' && table.body.length > 0) {
	<lbca-table-condensed [table]="table"
		[config]
		[disabled]="isDisabled"
		[lineCickable]="false"
		(order)="orderTable($event)"
		[cardData]="cardInfo"
	 />
}

@if (tableType === 'table-secondary' && table.body.length > 0) {
	<lbca-table-secondary [checkboxEntityKey]="fieldValues.entityKey"
		[checkItens]="'none'"
		(checkedItens)="sendMarkedItems($event)"
		[table]="table"
		[disabled]="isDisabled"
		[lineCickable]="false"
		(order)="orderTable($event)"
		[cardData]="cardInfo"
	 />
}

@if (table.body.length === 0) {
	<lbca-body-feedback type="table-list" class="table-list-feedback">
		<ng-container tableMessagePrimary>
			Nenhuma informação para
			<br />
			visualizar
		</ng-container>
	</lbca-body-feedback>
}
